import React, {
  forwardRef, useEffect, useImperativeHandle, useState
} from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  TextField,
  Grid,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  Select,
  Divider,
  InputAdornment,
  Tooltip,
  IconButton,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  Button,
  Link,
  Paper,
  Fab,
  Chip,
  Box,
  Autocomplete
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  Delete,
  ExpandMore,
  FileCopyOutlined,
  Send,
  MailOutlined,
  GetAppTwoTone,
} from '@mui/icons-material';
import AmountFormat from 'src/services/amountFormat';
import renderCellExpand from 'src/views/commons/RenderCellExpand';
import { DropzoneArea } from 'mui-file-dropzone';
import genService from 'src/services/generalServices';
import ordenService from 'src/services/ordenService';
import PropTypes from 'prop-types';
import combosService from 'src/services/combosService';
import GeneralBackDrop from 'src/views/commons/GeneralBackDrop';
/* import { format } from 'date-fns'; */
import { es as esLocale } from 'date-fns/locale/es';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DataGrid } from '@mui/x-data-grid';
import { Download } from 'react-feather';
import ConfirmationDialog from 'src/views/commons/ConfirmationDialog';
import NotificacionOrden from './NotificacionOrden';
import OrderGeneral from '../OrderCommons/OrderGeneral';

const useStyles = makeStyles((theme) => ({
  accordionDetails: {
    display: 'block'
  },
  dropZoneStyle: {
    minHeight: '100px',
  },
  dropZoneText: {
    fontWeight: '200',
    fontFamily: 'sans-serif'
  },
  rightMargin: {
    marginRight: theme.spacing(1),
    '&.MuiButtonBase-root': {
      marginRight: theme.spacing(1)
    }
  },
  control: {
    padding: theme.spacing(2),
  },
  tooltip: {
    backgroundColor: 'transparent',
    color: theme.palette.common.black,
    boxShadow: 'none'
  },
  verticalCenter: {
    alignItems: 'center',
    display: 'flex'
  }
}));

const AltaOrden = forwardRef(({
  formName,
  comboEstados,
  comboMunicipios,
  setComboMunicipios,
  mapaMunicipios,
  setMapaMunicipios,
  setServerError,
  setOpenSnackError,
  idOrden,
  setIdOrden,
  formData,
  setFormData,
  rowsOrdenes,
  setRowsOrdenes,
  comboClientes,
  comboAnalistas,
  comboOrdenEstatus,
  comboHiperliga,
  comboGradoEscolar,
  setComboGradoEscolar,
  mapaUsuarios,
  setMapaUsuarios,
  comboUsuarios,
  setComboUsuarios,
  setOpenSnackSuccess,
  setServerMessage,
  rolUsuario,
  setOpenAltaOrden
}, ref) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    trigger
  } = useForm();
  const classes = useStyles();
  const errorReq = 'Campo requerido.';
  const [acordionGeneral, setAcordionGeneral] = useState(true);
  const [acordionEvaluacion, setAcordionEvaluacion] = useState(true);
  const [acordionArchivos, setAcordionArchivos] = useState(true);
  const [acordionLiga, setAcordionLiga] = useState(true);
  const [valComboClientes, setValComboClientes] = useState({});
  const [valComboUsuarios, setValComboUsuarios] = useState({});
  const [valComboAnalistas, setValComboAnalistas] = useState({});
  const [valGradoEscolar, setValGradoEscolar] = useState({});
  const [folio, setFolio] = useState();
  const [rowsFiles, setRowsFiles] = useState([]);
  const [openFechaCita, setOpenFechaCita] = React.useState(false);
  const [fechaCita, setFechaCita] = React.useState(null);
  const [openFechaInicioLiga, setOpenFechaInicioLiga] = React.useState(false);
  const [fechaInicioLiga, setFechaInicioLiga] = React.useState(null);
  const [openFechaFinLiga, setOpenFechaFinLiga] = React.useState(false);
  const [fechaFinLiga, setFechaFinLiga] = React.useState(null);
  const [isLaboral, setIsLaboral] = useState(false);
  const [isEscuela, setIsEscuela] = useState(false);
  const [openBack, setOpenBack] = useState(false);
  const [llaveLiga, setLlaveLiga] = useState(null);
  const [linkDocs, setLinkDocs] = useState(null);
  const [linkTooltip, setLinkTooltip] = useState('Copiar Liga');
  const [correosLiga, setCorreosLiga] = useState([]);
  const [helperMailsMessage, setHelperMailsMessage] = useState(null);
  const [inputMailValue, setInputMailValue] = useState('');
  const [openEliminarMasiva, setOpenEliminarMasiva] = useState(false);
  const [openNotificacion, setOpenNotificacion] = useState(false);
  const [emailStatusData, setEmailStatusData] = useState({});
  const [deleteFileRow, setDeleteFileRow] = useState(null);
  const [idDireccion, setIdDireccion] = useState(0);
  const [estadoLigaVal, setEstadoLigaVal] = useState(true);
  const [fileSelected, setFileSelected] = useState([]);
  const [reqFechaCita, setReqFechaCita] = useState(false);
  const [reqComentarios, setReqComentarios] = useState(false);
  const [confirmarHiperliga, setConfirmarHiperliga] = useState(false);
  const [left, setLeft] = React.useState([]);
  const [right, setRight] = React.useState([]);
  const valEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

  /* const addComboMunicipios = (idEstado) => {
    const existMunicipios = mapaMunicipios.filter((item) => item.key === idEstado);
    if (existMunicipios !== undefined && existMunicipios.length > 0) {
      setComboMunicipios(existMunicipios[0].value);
    } else {
      combosService.comboMunicipios(idEstado).then((resp) => {
        setComboMunicipios(resp);
        setMapaMunicipios((newElement) => [...newElement, { key: idEstado, value: resp }]);
      });
    }
  }; */

  const getComboUsuarioCliente = async (idCliente, idUsuario) => {
    setValComboUsuarios({});
    setComboUsuarios([]);
    setOpenBack(true);
    const existUsuarios = mapaUsuarios.filter((item) => item.key === idCliente);
    if (existUsuarios !== undefined && existUsuarios.length > 0) {
      setComboUsuarios(existUsuarios[0].value);
      if (idUsuario !== null) {
        const selectComboUsuarios = existUsuarios[0].value.filter((aux) => (
          aux.value === idUsuario
        ));
        setValComboUsuarios(selectComboUsuarios[0]);
        if (selectComboUsuarios[0]) {
          setValue('regUsuario', selectComboUsuarios[0].usuario);
          clearErrors('regUsuario');
        }
      }
      setLeft(existUsuarios[0].value.filter((aux) => !aux.supervisor));
      setRight(existUsuarios[0].value.filter((aux) => aux.supervisor));
    } else if (idCliente !== undefined && idCliente > 0) {
      const isAdmin = rolUsuario === 'ADMINISTRADOR';
      await combosService.comboUsuariosCliente(idCliente, isAdmin).then((resp) => {
        setComboUsuarios(resp);
        setMapaUsuarios((newElement) => [...newElement, { key: idCliente, value: resp }]);
        if (idUsuario !== null) {
          const selectComboUsuarios = resp.filter((aux) => (
            aux.value === idUsuario
          ));
          setValComboUsuarios(selectComboUsuarios[0]);
          if (selectComboUsuarios[0]) {
            setValue('regUsuario', selectComboUsuarios[0].usuario);
            clearErrors('regUsuario');
          }
        }
        setLeft(resp.filter((aux) => !aux.supervisor));
        setRight(resp.filter((aux) => aux.supervisor));
      }).catch((error) => {
        console.log('Error al llenar el combo de usuarios', error);
        setOpenBack(false);
      });
    }
    setOpenBack(false);
  };

  const getComboGradoEscolar = (idCliente, idGradoEscolar) => {
    if (idCliente !== undefined && idCliente > 0) {
      combosService.comboGradoEscolar(idCliente).then((resp) => {
        setComboGradoEscolar(resp);
        if (idGradoEscolar !== undefined && idGradoEscolar > 0) {
          const selecGrado = resp.filter((aux) => aux.value === idGradoEscolar);
          setValGradoEscolar(selecGrado[0]);
        }
      });
    }
  };

  const resetForm = () => {
    reset({
      id: 0,
      regCliente: '',
      ordenStatus: '',
      comentarios: '',
      importeFacturar: '',
      fechaSolicitudStr: ''
    });
    setValComboClientes({});
    setValComboUsuarios({});
    setValComboAnalistas({});
    setComboUsuarios([]);
    setIsLaboral(false);
    setIsEscuela(false);
    combosService.addComboMunicipios(9, mapaMunicipios,
      setComboMunicipios, setMapaMunicipios);
    setRowsFiles([]);
    setFolio(ordenService.generarFolio());
    const currentDate = new Date();
    const currDateOneMonth = new Date();
    setFechaInicioLiga(currentDate);
    currDateOneMonth.setMonth(currDateOneMonth.getMonth() + 1);
    setFechaFinLiga(currDateOneMonth);
    setFechaCita(null);
    setCorreosLiga([]);
    setEstadoLigaVal(true);
    setReqComentarios(false);
    setReqFechaCita(false);
  };

  const optionsCliente = comboClientes.map((option) => {
    const firstLetter = option.tipoCliente;
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    };
  });

  useEffect(() => {
    if (formData.id !== undefined && formData.id > 0) {
      setIdOrden(formData.id);
      setIdDireccion(formData.direccion.id);
      setFolio(formData.folio);
      const selectComboClientes = optionsCliente.filter((aux) => (
        aux.value === formData.idCliente
      ));
      setValComboClientes(selectComboClientes[0]);
      if (selectComboClientes[0].tipoCliente === 'Escuela') {
        setIsEscuela(true);
      } else if (selectComboClientes[0].tipoCliente === 'Laboral') {
        setIsLaboral(true);
      }
      setFechaCita(formData.fechaCita ? new Date(formData.fechaCita) : null);
      const selectComboAnalistas = comboAnalistas.filter((aux) => (
        formData.idAnalista === aux.value
      ));
      if (selectComboAnalistas.length > 0) {
        setValComboAnalistas(selectComboAnalistas[0]);
      }
      getComboGradoEscolar(formData.idCliente, formData.idGradoEscolar);
      if (formData.archivos !== null && formData.archivos !== undefined
        && formData.archivos.length > 0) {
        setRowsFiles(formData.archivos);
        setAcordionArchivos(true);
      } else {
        setAcordionArchivos(false);
      }
      if (formData.listCorreosLiga !== null && formData.listCorreosLiga !== undefined) {
        setCorreosLiga(formData.listCorreosLiga);
      }
      setFechaInicioLiga(formData.fechaInicioLiga ? new Date(formData.fechaInicioLiga) : null);
      setFechaFinLiga(formData.fechaFinLiga ? new Date(formData.fechaFinLiga) : null);
      setEstadoLigaVal(formData.estadoLiga);
      setLinkDocs(`${window.location.origin}/cargaDocumentos?key=${formData.llaveLiga}`);
      setLlaveLiga(formData.llaveLiga);
      const llenaComboUsuarios = async (idCliente, idUsuario) => {
        await getComboUsuarioCliente(idCliente, idUsuario);
      };
      llenaComboUsuarios(formData.idCliente, formData.idUsuarioCliente);
      const orderStatus = comboOrdenEstatus.filter(
        (auxStatus) => auxStatus.value === formData.idOrdenEstatus
      );
      if (orderStatus !== undefined && orderStatus !== null
      && orderStatus[0].label === 'CITA') {
        setReqFechaCita(true);
      } else if ((orderStatus !== undefined && orderStatus !== null && orderStatus[0].label === 'SUSPENDIDO')) {
        setReqComentarios(true);
      }
      const nombreCliente = comboClientes.filter(
        (auxCliente) => auxCliente.value === formData.idCliente
      );
      setEmailStatusData({
        nombreCliente: nombreCliente[0].label,
        folio: formData.folio,
        descOrdenEstatus: orderStatus[0].label,
        nombre: formData.nombre,
        fechaCita: formData.fechaCita,
        comentarios: formData.comentarios
      });
    } else {
      setIdOrden(0);
      setFolio(ordenService.generarFolio());
      setFormData({});
      setComboGradoEscolar([]);
      const currentDate = new Date();
      const currDateOneMonth = new Date();
      setFechaInicioLiga(currentDate);
      currDateOneMonth.setMonth(currDateOneMonth.getMonth() + 1);
      setFechaFinLiga(currDateOneMonth);
    }
    if (formData.direccion?.idEstado !== undefined
      && formData.direccion?.idEstado !== null
      && formData.direccion.idEstado > 0) {
      combosService.addComboMunicipios(formData.direccion.idEstado,
        mapaMunicipios, setComboMunicipios, setMapaMunicipios);
    } else {
      combosService.addComboMunicipios(9, mapaMunicipios,
        setComboMunicipios, setMapaMunicipios);
    }
    reset(formData);
    if (formData.id !== undefined && formData.id > 0) {
      setValue('fechaCita', formData.fechaCita ? new Date(formData.fechaCita) : null);
      if (formData.idUsuarioCliente) {
        setValue('regUsuario', 'x');
        clearErrors('regUsuario');
      }
    }
    setFormData({});
  }, []);

  const getComboMunicipios = (newValue) => {
    setComboMunicipios([]);
    if (newValue !== null) {
      setValue('idMunicipio', '');
      combosService.addComboMunicipios(newValue, mapaMunicipios,
        setComboMunicipios, setMapaMunicipios);
    }
  };

  const onError = (err) => {
    if (err.nombreCliente || err.nombre || err.puesto || err.matricula
      || err.telefonoPrimario) {
      setAcordionGeneral(true);
    }
    if (err.idOrdenEstatus) {
      setAcordionEvaluacion(true);
    }
  };

  const agregaArchivos = (fileList) => {
    let filesList = [];
    const uploadFileToS3 = async (file) => {
      setOpenBack(true);
      if (filesList.length === 0) {
        filesList = rowsFiles.slice();
      }
      const existingFile = filesList.findIndex((auxFile) => auxFile.nombre === file.name);
      let nombreArchivo = file.name;
      const nombreSinExtension = nombreArchivo.substring(0, nombreArchivo.lastIndexOf('.'));
      if (nombreSinExtension.length > 50) {
        const extension = nombreArchivo.substring(nombreArchivo.lastIndexOf('.'), nombreArchivo.length);
        const nombreCorto = nombreSinExtension.substring(0, 50);
        nombreArchivo = nombreCorto.trim() + extension;
        setOpenSnackError(true);
        setServerError('El nombre de alguno de sus archivos fue reducido a 50 caracteres.');
      }
      // let uploadedFile;
      if (existingFile < 0) {
        const itemFile = {
          id: `${folio}_${nombreArchivo}`,
          nombre: nombreArchivo,
          size: file.size,
          fileBucketName: `GENERAL_${folio}_${nombreArchivo}`,
          comentarios: '',
          estatus: 'NUEVO',
          tipoArchivo: 'GENERAL',
          archivo: file,
          enServidor: false
        };
        filesList.push(itemFile);
        // uploadedFile = itemFile;
      } else {
        filesList[existingFile].archivo = file;
        filesList[existingFile].size = file.size;
        if (filesList[existingFile].estatus !== 'NUEVO') {
          filesList[existingFile].estatus = 'ACTUALIZADO';
        }
        // uploadedFile = filesList[existingFile];
      }
      /* await ordenService.uploadArchivoAWS(uploadedFile, file); */
      setOpenBack(false);
    };

    fileList.forEach((file) => {
      uploadFileToS3(file);
    });
    setRowsFiles(filesList);
  };

  /* const onClickRemove = () => {
    const listFiles = rowsFiles.filter((row) => row.id !== deleteFileRow.id);
    console.log('El archivo a borrar:', deleteFileRow);
    if (deleteFileRow.enServidor) {
      const deleteFile = rowsFiles.filter((row) => row.id === deleteFileRow.id);
      ordenService.deleteOrderFile(deleteFile[0]).catch((error) => console.log(error));
    }
    setRowsFiles(listFiles);
    setOpenEliminar(false);
    setDeleteFileRow(null);
  }; */

  const deleteMasiveFiles = async () => {
    setOpenBack(true);
    setOpenEliminarMasiva(false);
    let selectedRows = [];
    let nonSelectedRows = [];
    if (deleteFileRow !== null) {
      selectedRows = rowsFiles.filter((row) => (
        row.id === deleteFileRow.id && row.enServidor
      ));
      nonSelectedRows = rowsFiles.filter((row) => row.id !== deleteFileRow.id);
    } else {
      selectedRows = rowsFiles.filter(({ id, enServidor }) => (
        fileSelected.includes(id) && enServidor
      ));
      nonSelectedRows = rowsFiles.filter(({ id }) => !fileSelected.includes(id));
    }
    if (selectedRows.length > 0) {
      await ordenService.deleteOrderFile(selectedRows).then((resp) => {
        setRowsFiles(nonSelectedRows);
        setOpenSnackSuccess(true);
        setServerMessage(resp.data.mensaje);
      }).catch((error) => {
        setOpenSnackError(true);
        if (error.response) {
          setServerError(error.response.data.message);
        } else {
          setServerError(`${error.message}: No fue posible conectar con el servidor`);
        }
      });
    } else {
      setRowsFiles(nonSelectedRows);
    }
    setDeleteFileRow(null);
    setOpenBack(false);
  };

  const onClickEnviarHiperliga = async () => {
    const emailData = {};
    emailData.nombreCliente = getValues('nombre');
    emailData.listCorreosLiga = correosLiga;
    emailData.folio = folio;
    emailData.llaveLiga = linkDocs;
    setOpenBack(true);
    setConfirmarHiperliga(false);
    await ordenService.enviarEmailLiga(emailData).then(() => {
      setServerMessage(`El correo con la liga para la orden ${folio} fue enviado correctamente.`);
      setOpenSnackSuccess(true);
    }).catch((error) => {
      console.log('Error al enviar correo de liga:', error);
      setOpenSnackError(true);
      setServerError(`Error al enviar correo de liga para la orden ${folio}`);
      setConfirmarHiperliga(false);
      setOpenBack(false);
    });
    setOpenBack(false);
  };

  const onAddCorreos = (newVal) => {
    const lastVal = newVal.trim();
    setHelperMailsMessage(null);
    setInputMailValue('');
    if (newVal !== undefined && valEmail.test(newVal.trim())) {
      const filtraCorreo = correosLiga.filter((mail) => lastVal === mail);
      if (filtraCorreo.length > 0) {
        setHelperMailsMessage('Este correo ya fue ingresado anteriormente.');
        setInputMailValue(newVal.trim());
      } else {
        correosLiga.push(newVal.trim());
      }
    } else if (lastVal !== undefined && lastVal !== '') {
      setHelperMailsMessage('Verificar el formato del correo ingresado.');
      setInputMailValue(newVal.trim());
    }
  };

  const onSubmit = (data, isNotificacion) => {
    const handleAsync = async (datos) => {
      setOpenBack(true);
      await ordenService.altaOrden(datos).then((resp) => {
        if (resp.data != null && resp.data.errorCode === 204) {
          setServerError(resp.data.mensaje);
          setOpenSnackError(true);
        } else {
          if (idOrden > 0 && rowsOrdenes !== undefined && rowsOrdenes !== null
            && setRowsOrdenes !== undefined) {
            // El endpoint de actualización devuelve el mismo DTO enviado, sin los
            // campos de join (nombreUsuario, nombreCliente) que solo llena la
            // consulta de búsqueda: se toman del combo seleccionado en el formulario,
            // que sí refleja el valor vigente aunque el usuario lo haya cambiado.
            // numberOfDocs sí se puede derivar del arreglo de archivos actualizado
            // que el backend devuelve.
            setRowsOrdenes(rowsOrdenes.map((row) => (
              row.id === idOrden
                ? {
                  ...row,
                  ...resp.data,
                  nombreUsuario: valComboUsuarios?.usuario || row.nombreUsuario,
                  nombreCliente: valComboClientes?.label || row.nombreCliente,
                  numberOfDocs: resp.data.archivos
                    ? resp.data.archivos.length : row.numberOfDocs,
                  descOrdenEstatus: resp.data.strOrdenEstatus
                }
                : row
            )));
          }
          // Se agregó un nuevo grado escolar, se debe actualizar el combo.
          if (data.gradoEscolar && data.gradoEscolar.value === 0) {
            data.gradoEscolar.value = resp.data.gradoEscolar.value;
          }
          /* setOpen(true); */
          setOpenSnackSuccess(true);
          setServerMessage(`La orden ${folio} fue guardada exitosamente.`);
          setIdOrden(resp.data.id);
          setIdDireccion(resp.data.direccion.id);
          setLinkDocs(`${window.location.origin}/cargaDocumentos?key=${resp.data.llaveLiga}`);
          setLlaveLiga(resp.data.llaveLiga);
          setValue('fechaTermino', resp.data.fechaTermino);
          setValue('fechaFinalizacionLigaStr', resp.data.fechaFinalizacionLigaStr);
          setRowsFiles(resp.data.archivos);
          emailStatusData.descOrdenEstatus = resp.data.strOrdenEstatus;
          emailStatusData.nombre = resp.data.nombre;
          emailStatusData.fechaCita = resp.data.fechaCita;
          emailStatusData.comentarios = resp.data.comentarios;
          if (isNotificacion === true) {
            setOpenNotificacion(true);
          } else {
            setOpenAltaOrden(false);
          }
        }
      }).catch((error) => {
        if (error.response !== undefined) {
          setServerError(error.response.data.message);
        } else {
          setServerError(`${error.message}: No fue posible conectar con el servidor`);
        }
        setOpenSnackError(true);
      }).finally(() => {
        setOpenBack(false);
      });
      setOpenBack(false);
    };
    data.id = idOrden;
    data.folio = folio;
    if (idOrden === 0) {
      data.direccion.id = 0;
    }
    data.idUsuarioCliente = valComboUsuarios.value;
    data.idCliente = valComboClientes.value;
    data.idGradoEscolar = isEscuela ? (valGradoEscolar?.value || 0) : 0;
    data.matricula = isEscuela ? data.matricula : '';
    data.puesto = isLaboral ? data.puesto : '';
    data.archivos = rowsFiles.map((auxFile) => {
      if (auxFile.estatus === 'NUEVO') {
        auxFile.id = 0;
      }
      return auxFile;
    });
    data.fechaInicioLiga = fechaInicioLiga;
    data.fechaFinLiga = fechaFinLiga;
    data.fechaCita = fechaCita;
    data.listCorreosLiga = correosLiga;
    data.idAnalista = valComboAnalistas?.value;
    data.gradoEscolar = isEscuela && valGradoEscolar?.label ? valGradoEscolar : null;
    data.direccion.id = idDireccion;
    data.estadoLiga = estadoLigaVal;
    data.llaveLiga = llaveLiga;
    const estatusSelec = comboOrdenEstatus.filter(
      (auxEstatus) => data.idOrdenEstatus === auxEstatus.value
    );
    data.strOrdenEstatus = estatusSelec[0].label;
    data.descEstatusLiga = comboHiperliga.filter(
      (edoLink) => data.idEstatusLiga === edoLink.value
    )[0]?.label;
    handleAsync(data);
  };

  useImperativeHandle(ref, () => ({
    resetOrdenForm: () => {
      resetForm();
    },
    sendOrderStatusEmail: async () => {
      await trigger().then((res) => {
        if (res) {
          onSubmit(getValues(), true);
        } else {
          const firstError = Object.keys(errors)[0];
          errors[firstError]?.ref.focus();
        }
      });
    }
  }));

  const descargaMasiva = async () => {
    setOpenBack(true);
    const selectedRows = rowsFiles.filter(({ id }) => fileSelected.includes(id));
    const files = selectedRows.filter((auxFile) => auxFile.archivo !== undefined)
      .map((filteredFile) => filteredFile.archivo);
    const filesObject = selectedRows.filter((auxFile) => auxFile.estatus !== 'NUEVO');
    await ordenService.descargarZip(filesObject, files, folio).then((response) => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.data);
      link.download = `${folio}.zip`;
      link.click();
    }).catch((e) => {
      if (e.response) {
        e.response.data.text().then((errorResp) => {
          const finalError = JSON.parse(errorResp);
          setServerError(finalError.message);
        });
      } else {
        setServerError(`${e.message}: No fue posible conectar con el servidor`);
      }
      setOpenSnackError(true);
    });
    setOpenBack(false);
  };

  const columnsFiles = [
    {
      field: 'tipoArchivo',
      headerName: 'Tipo de Archivo',
      minWidth: 120,
      flex: 1,
      hideSortIcons: true
    },
    {
      field: 'nombre',
      headerName: 'Nombre de Archivo',
      minWidth: 120,
      flex: 1,
      renderCell: renderCellExpand
    },
    {
      field: 'comentarios',
      headerName: 'Comentarios',
      minWidth: 120,
      flex: 1,
      renderCell: renderCellExpand
    },
    {
      field: 'acciones',
      headerName: 'Acciones',
      maxWidth: 100,
      minWidth: 100,
      sortable: false,
      disableClickEventBubbling: true,
      align: 'center',
      renderCell: (params) => {
        const onClickDownload = () => {
          const link = document.createElement('a');
          if (params.row.archivo !== undefined) {
            link.href = window.URL.createObjectURL(params.row.archivo);
            link.download = params.row.nombre;
            link.click();
          } else {
            const downloadFileAsync = async (datos) => {
              setOpenBack(true);
              await ordenService.downloadArchivoAWS(datos).then((resp) => {
                link.href = window.URL.createObjectURL(resp.data);
                // params.row.archivo = resp.data;
                link.download = params.row.nombre;
                link.click();
              }).catch((e) => {
                console.log('Error al descargar el archivo', e);
                setOpenBack(false);
                setServerError(e.message);
                setOpenSnackError(true);
              });
              setOpenBack(false);
            };
            downloadFileAsync(params.row);
          }
        };
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%'
            }}
          >
            <Tooltip title="Eliminar">
              <IconButton
                className={classes.customHoverFocus}
                onClick={() => {
                  setOpenEliminarMasiva(true);
                  setDeleteFileRow(params.row);
                }}
                fontSize="small"
                color="primary"
                size="large"
              >
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Descargar">
              <IconButton
                className={classes.customHoverFocus}
                onClick={onClickDownload}
                fontSize="small"
                color="primary"
                size="large"
              >
                <Download fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    }
  ];

  return (
    <div>
      <Accordion expanded={acordionGeneral}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          onClick={() => setAcordionGeneral(!acordionGeneral)}
        >
          <Typography variant="h4">Datos Generales</Typography>
        </AccordionSummary>
        <Divider />
        <AccordionDetails className={classes.accordionDetails}>
          <form
            id={formName}
            onSubmit={handleSubmit(onSubmit, onError)}
          >
            <OrderGeneral
              register={register}
              folio={folio}
              errors={errors}
              isLaboral={isLaboral}
              isEscuela={isEscuela}
              idOrden={idOrden}
              comboGradoEscolar={comboGradoEscolar}
              valGradoEscolar={valGradoEscolar}
              setValGradoEscolar={setValGradoEscolar}
              setValue={setValue}
              setError={setError}
              clearErrors={clearErrors}
              optionsCliente={optionsCliente}
              valComboClientes={valComboClientes}
              setValComboClientes={setValComboClientes}
              setIsEscuela={setIsEscuela}
              setIsLaboral={setIsLaboral}
              getComboGradoEscolar={getComboGradoEscolar}
              getComboUsuarioCliente={getComboUsuarioCliente}
              comboUsuarios={comboUsuarios}
              valComboUsuarios={valComboUsuarios}
              setValComboUsuarios={setValComboUsuarios}
              rolUsuario={rolUsuario}
              comboEstados={comboEstados}
              comboMunicipios={comboMunicipios}
              getComboMunicipios={getComboMunicipios}
              control={control}
            />
          </form>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={acordionEvaluacion}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          onClick={() => setAcordionEvaluacion(!acordionEvaluacion)}
        >
          <Typography variant="h4">Evaluación</Typography>
        </AccordionSummary>
        <Divider />
        <AccordionDetails className={classes.accordionDetails}>
          <form
            id={formName}
            onSubmit={handleSubmit(onSubmit, onError)}
          >
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
                  fullWidth
                >
                  <InputLabel htmlFor="ordenEstatus-select">
                    {
                      errors.idOrdenEstatus
                        ? <div style={{ color: '#f44336' }}>Seleccione un Estatus *</div>
                        : <div>Seleccione un Estatus *</div>
                    }
                  </InputLabel>
                  <Controller
                    control={control}
                    name="idOrdenEstatus"
                    rules={{ required: { value: true, message: errorReq } }}
                    defaultValue={comboOrdenEstatus[0].value}
                    render={({ field }) => (
                      <Select
                        {...field}
                        id="OrdenEstatus-select"
                        label="Seleccione un Estatus"
                        onChange={(evento, newValue) => {
                          field.onChange(newValue.props.value);
                          setReqFechaCita(false);
                          setReqComentarios(false);
                          clearErrors(['comentarios', 'fechaCita']);
                          if (newValue.props.children === 'CITA') {
                            setReqFechaCita(true);
                          } else if (newValue.props.children === 'SUSPENDIDO') {
                            setReqComentarios(true);
                          }
                        }}
                      >
                        {comboOrdenEstatus.map((status) => (
                          <MenuItem
                            key={status.value}
                            value={status.value}
                          >
                            {status.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  {
                    errors.idOrdenEstatus
                    && (
                      <FormHelperText style={{ color: '#f44336' }}>
                        {errors.idOrdenEstatus?.message}
                      </FormHelperText>
                    )
                  }
                </FormControl>
              </Grid>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  label="Fecha de Solicitud"
                  slotProps={{
                    htmlInput: { readOnly: true },
                    inputLabel: { shrink: true }
                  }}
                  {...register('fechaSolicitudStr')}
                  variant="filled"
                  fullWidth
                  size="small"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                  <Controller
                    control={control}
                    name="fechaCita"
                    defaultValue={null}
                    rules={{ required: { value: reqFechaCita, message: 'Debe ingresar una fecha de cita.' } }}
                    render={({ field }) => (
                      <DateTimePicker
                        open={openFechaCita}
                        onOpen={() => setOpenFechaCita(true)}
                        onClose={() => setOpenFechaCita(false)}
                        onChange={(newValue) => {
                          field.onChange(newValue);
                          setFechaCita(newValue);
                        }}
                        format="dd/MM/yyyy HH:mm:ss"
                        label={reqFechaCita ? 'Fecha de Cita *' : 'Fecha de Cita'}
                        value={fechaCita}
                        slotProps={{
                          textField: {
                            name: 'fechaCita',
                            margin: 'none',
                            fullWidth: true,
                            error: !!errors.fechaCita,
                            helperText: errors.fechaCita?.message,
                            onBlur: field.onBlur,
                            inputRef: field.ref
                          }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  label="Fecha de Termino"
                  slotProps={{
                    htmlInput: { readOnly: true },
                    inputLabel: { shrink: true }
                  }}
                  {...register('fechaTermino')}
                  variant="filled"
                  fullWidth
                  size="small"
                />
              </Grid>
            </Grid>
            {rolUsuario === 'ADMINISTRADOR'
              ? (
                <Grid container spacing={3}>
                  <Grid
                    size={{
                      md: 6,
                      xs: 12
                    }}
                  >
                    <Autocomplete
                      id="combo-box-analista"
                      options={comboAnalistas}
                      getOptionLabel={(option) => (option.label ? `${option.label} - (${option.usuario})` : '')}
                      fullWidth
                      value={valComboAnalistas}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          {...register('regAnalista')}
                          label="Seleccione un Analista"
                          variant="outlined"
                          size="small"
                          error={!!errors.regAnalista}
                          helperText={errors.regAnalista?.message}
                          onInput={genService.toUpperCase}
                        />
                      )}
                      onChange={(event, newValue) => {
                        clearErrors('regAnalista');
                        setValComboAnalistas(newValue);
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      md: 6,
                      xs: 12
                    }}
                  >
                    <TextField
                      label="Importe a Facturar"
                      {...register('importeFacturar')}
                      defaultValue={formData.importeFacturar}
                      slotProps={{
                        input: {
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                          inputComponent: AmountFormat,
                        }
                      }}
                      fullWidth
                      size="small"
                      variant="outlined"
                      error={!!errors.importeFacturar}
                      helperText={errors.importeFacturar?.message}
                    />
                  </Grid>
                </Grid>
              ) : (
                null
              )}
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 12,
                  xs: 12
                }}
              >
                <TextField
                  label={reqComentarios ? 'Comentarios *' : 'Comentarios'}
                  variant="outlined"
                  fullWidth
                  size="small"
                  multiline
                  minRows={3}
                  onInput={genService.toUpperCase}
                  error={!!errors.comentarios}
                  helperText={errors.comentarios?.message}
                  {...register('comentarios', {
                    required: { value: reqComentarios, message: 'Para guardar la orden es necesario agregar un comentario.' },
                  })}
                />
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
      {rolUsuario === 'ADMINISTRADOR'
        ? (
          <Accordion expanded={acordionLiga}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              onClick={() => setAcordionLiga(!acordionLiga)}
            >
              <Typography variant="h4">Link Hiperliga</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails className={classes.accordionDetails}>
              <form
                id={formName}
                onSubmit={handleSubmit(onSubmit, onError)}
              >
                { idOrden > 0
                  ? (
                    <Grid
                      container
                      spacing={3}
                      sx={{
                        justifyContent: 'center'
                      }}
                    >
                      <Grid>
                        <Paper className={classes.control}>
                          <Link href={linkDocs} target="_blank">
                            {linkDocs}
                          </Link>
                        </Paper>
                      </Grid>
                      <Grid className={classes.verticalCenter}>
                        <Tooltip
                          title={linkTooltip}
                          className={classes.tooltip}
                          leaveDelay="500"
                          arrow
                          onClose={() => setLinkTooltip('Copiar Liga')}
                        >
                          <Fab
                            aria-label="edit"
                            size="small"
                            onClick={() => {
                              navigator.clipboard.writeText(linkDocs);
                              setLinkTooltip('Link Copiado!');
                            }}
                            color="transparent"
                          >
                            <FileCopyOutlined />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  ) : (
                    null
                  )}
                <Grid container spacing={3}>
                  <Grid
                    size={{
                      md: 6,
                      xs: 12
                    }}
                  >
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Estado Liga</FormLabel>
                      <RadioGroup
                        row
                        value={estadoLigaVal}
                        onChange={(e) => {
                          if (e.currentTarget.value === 'true') {
                            setEstadoLigaVal(true);
                          } else {
                            setEstadoLigaVal(false);
                          }
                        }}
                      >
                        <FormControlLabel
                          control={<Radio color="primary" />}
                          label="Activo"
                          value
                          labelPlacement="start"
                        />
                        <FormControlLabel
                          control={<Radio color="primary" />}
                          label="Inactivo"
                          value={false}
                          labelPlacement="start"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid
                    size={{
                      md: 6,
                      xs: 12
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                      <DatePicker
                        open={openFechaInicioLiga}
                        onOpen={() => setOpenFechaInicioLiga(true)}
                        onClose={() => setOpenFechaInicioLiga(false)}
                        format="dd/MM/yyyy"
                        label="Vigencia Inicio"
                        value={fechaInicioLiga}
                        onChange={(newDate) => {
                          setFechaInicioLiga(newDate);
                          if (new Date(newDate) > new Date(fechaFinLiga)) {
                            setError('fechaInicioLiga', { type: 'custom', message: 'La fecha de Inicio no puede ser mayor a la fecha de Fin.' });
                          } else {
                            clearErrors();
                          }
                        }}
                        slotProps={{
                          textField: {
                            name: 'fechaInicioLiga',
                            margin: 'none',
                            fullWidth: true,
                            error: !!errors.fechaInicioLiga,
                            helperText: errors.fechaInicioLiga?.message
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid
                    size={{
                      md: 6,
                      xs: 12
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                      <DatePicker
                        open={openFechaFinLiga}
                        onOpen={() => setOpenFechaFinLiga(true)}
                        onClose={() => setOpenFechaFinLiga(false)}
                        format="dd/MM/yyyy"
                        label="Vigencia Fin"
                        value={fechaFinLiga}
                        onChange={(newDate) => {
                          setFechaFinLiga(newDate);
                          if (new Date(newDate) < new Date(fechaInicioLiga)) {
                            setError('fechaFinLiga', { type: 'custom', message: 'La fecha de Fin no puede ser menor a la fecha de Inicio.' });
                          } else {
                            clearErrors();
                          }
                        }}
                        slotProps={{
                          textField: {
                            name: 'fechaFinLiga',
                            margin: 'none',
                            fullWidth: true,
                            error: !!errors.fechaFinLiga,
                            helperText: errors.fechaFinLiga?.message
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid
                    size={{
                      md: 10,
                      xs: 9
                    }}
                  >
                    <Autocomplete
                      multiple
                      freeSolo
                      id="tags-outlined"
                      options={[]}
                      value={correosLiga}
                      inputValue={inputMailValue}
                      onInputChange={(e, newValue, reason) => {
                        if (reason === 'input') {
                          setInputMailValue(newValue);
                        }
                      }}
                      onChange={() => {
                        onAddCorreos(inputMailValue);
                      }}
                      renderValue={(value, getItemProps) => (
                        value.map((option, index) => (
                          <Chip
                            variant="outlined"
                            label={option}
                            {...getItemProps({ index })}
                            color="primary"
                            icon={<MailOutlined />}
                            clickable
                            onClick={() => {
                              if (inputMailValue !== '' && valEmail.test(inputMailValue)) {
                                const addValue = correosLiga.push(inputMailValue);
                                setCorreosLiga(addValue);
                                setInputMailValue('');
                              }
                              const tempArray = correosLiga.filter((item) => (
                                item !== correosLiga[index]
                              ));
                              setInputMailValue(correosLiga[index]);
                              setCorreosLiga(tempArray);
                            }}
                            onDelete={() => {
                              const newCorreosList = correosLiga.filter((mail) => mail !== option);
                              setCorreosLiga(newCorreosList);
                            }}
                          />
                        )))}
                      disableClearable
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Correos para envío de liga"
                          placeholder="Ingrese un correo..."
                          error={helperMailsMessage !== null}
                          helperText={helperMailsMessage}
                          onInput={genService.toLowerCase}
                          onKeyDown={(e) => {
                            if (e.keyCode === 32) {
                              onAddCorreos(inputMailValue);
                            }
                          }}
                          onBlur={() => {
                            onAddCorreos(inputMailValue);
                          }}
                          onKeyUp={(e) => {
                            if (e.keyCode === 32 && inputMailValue === ' ') {
                              setInputMailValue('');
                            }
                          }}
                        />
                      )}
                    />
                  </Grid>
                  {idOrden > 0 && correosLiga?.length > 0
                    ? (
                      <Grid
                        className={classes.verticalCenter}
                        size={{
                          md: 2,
                          xs: 3
                        }}
                      >
                        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                          <Tooltip title="Enviar Correo Liga">
                            <Button
                              variant="contained"
                              color="primary"
                              endIcon={<Send />}
                              onClick={() => setConfirmarHiperliga(true)}
                            >
                              ENVIAR
                            </Button>
                          </Tooltip>
                        </Box>
                        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                          <Tooltip title="Enviar Correos">
                            <Button variant="contained" color="primary" endIcon={<Send />} />
                          </Tooltip>
                        </Box>
                      </Grid>
                    ) : (
                      null
                    )}
                </Grid>
                <Grid container spacing={3}>
                  <Grid
                    size={{
                      md: 6,
                      xs: 12
                    }}
                  >
                    <FormControl
                      control={control}
                      variant="outlined"
                      size="small"
                      className={classes.formControl}
                      fullWidth
                    >
                      <InputLabel htmlFor="linkEstatus-select">
                        {
                          errors.idEstatusLiga
                            ? <div style={{ color: '#f44336' }}>Seleccione un Estatus *</div>
                            : <div>Seleccione un Estatus *</div>
                        }
                      </InputLabel>
                      <Controller
                        control={control}
                        name="idEstatusLiga"
                        rules={{ required: { value: true, message: errorReq } }}
                        defaultValue={comboHiperliga[0].value}
                        render={({ field }) => (
                          <Select
                            {...field}
                            id="LinkEstatus-select"
                            label="Estatus de Hipeliga"
                            onChange={(evento, newValue) => {
                              field.onChange(newValue.props.value);
                            }}
                          >
                            {comboHiperliga.map((status) => (
                              <MenuItem
                                key={status.value}
                                value={status.value}
                              >
                                {status.label}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      {
                        errors.idEstatusLiga
                        && (
                          <FormHelperText style={{ color: '#f44336' }}>
                            {errors.idEstatusLiga?.message}
                          </FormHelperText>
                        )
                      }
                    </FormControl>
                  </Grid>
                  <Grid
                    size={{
                      md: 6,
                      xs: 12
                    }}
                  >
                    <TextField
                      label="Fecha de Finalización"
                      slotProps={{
                        htmlInput: { readOnly: true },
                        inputLabel: { shrink: true }
                      }}
                      {...register('fechaFinalizacionLigaStr')}
                      variant="filled"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                </Grid>
              </form>
            </AccordionDetails>
          </Accordion>
        ) : (
          null
        )}
      {rolUsuario === 'ADMINISTRADOR'
        ? (
          <Accordion expanded={acordionArchivos}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              onClick={() => setAcordionArchivos(!acordionArchivos)}
            >
              <Typography variant="h4">Archivos Adjuntos</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails className={classes.accordionDetails}>
              <Grid
                container
                spacing={3}
                sx={{
                  justifyContent: 'center'
                }}
              >
                <Grid
                  size={{
                    md: 9,
                    xs: 12
                  }}
                >
                  <DropzoneArea
                    dropzoneClass={classes.dropZoneStyle}
                    acceptedFiles={[
                      'application/pdf',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                      'application/x-zip-compressed',
                      'application/msword',
                      'application/vnd.ms-excel',
                      '.ppt',
                      '.pttx',
                      'text/plain',
                      'image/png',
                      'image/jpeg',
                    ]}
                    onDrop={(file) => {
                      agregaArchivos(file);
                    }}
                    filesLimit={500}
                    dropzoneText={(
                      <div>
                        <div>Arrastre y suelte un archivo.</div>
                        <div style={{ fontWeight: '100', fontFamily: 'sans-serif', fontStyle: 'italic' }}>
                          (Máx 3 MB y con extensiones: .jpg, .png, .pdf,
                          .zip, .doc-x, .xls-x, .ppt-x y .txt)
                        </div>
                      </div>
                    )}
                    maxFileSize={3200000}
                    showPreviewsInDropzone={false}
                    alertSnackbarProps={{ anchorOrigin: { vertical: 'bottom', horizontal: 'center' } }}
                    showAlerts={['error']}
                    getDropRejectMessage={() => {
                      return 'Solo se aceptan archivos menores a 3 MB y con extensiones: .jpg, .png, .pdf, .zip, .doc-x, .xls-x, .ppt-x y .txt';
                    }}
                  />
                </Grid>
              </Grid>
              {fileSelected.length > 1 ? (
                <Grid
                  container
                  spacing={3}
                  style={{ display: rowsFiles.length > 0 ? '' : 'none' }}
                  sx={{
                    justifyContent: 'center'
                  }}
                >
                  <Grid
                    align="right"
                    size={{
                      md: 12,
                      xs: 12,
                      sm: 12
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                      }}
                    >
                      <Tooltip title="Eliminar selección">
                        <Button
                          className={classes.rightMargin}
                          variant="contained"
                          color="primary"
                          endIcon={<Delete />}
                          onClick={() => setOpenEliminarMasiva(true)}
                        >
                          ELIMINAR
                        </Button>
                      </Tooltip>
                      <Tooltip title="Descargar selección">
                        <Button
                          variant="contained"
                          color="primary"
                          endIcon={<GetAppTwoTone />}
                          onClick={descargaMasiva}
                        >
                          Descargar
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>
                </Grid>
              ) : ''}
              <Grid
                container
                spacing={3}
                style={{ display: rowsFiles.length > 0 ? '' : 'none' }}
                sx={{
                  justifyContent: 'center'
                }}
              >
                <Grid
                  align="center"
                  size={{
                    md: 12,
                    xs: 12,
                    sm: 12
                  }}
                >
                  <DataGrid
                    rows={rowsFiles}
                    columns={columnsFiles}
                    autoHeight
                    density="compact"
                    disableColumnFilter
                    disableColumnMenu
                    disableVirtualization
                    initialState={{ pagination: { paginationModel: { pageSize: 100 } } }}
                    pagination
                    pageSizeOptions={[100]}
                    checkboxSelection
                    disableRowSelectionExcludeModel
                    disableRowSelectionOnClick
                    onRowSelectionModelChange={(selec) => {
                      setFileSelected(Array.from(selec.ids));
                    }}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        ) : (
          null
        )}
      <GeneralBackDrop open={openBack} />
      <ConfirmationDialog
        keepMounted
        open={openEliminarMasiva}
        onClose={() => {
          setOpenEliminarMasiva(false);
          setDeleteFileRow(null);
        }}
        confirm={deleteMasiveFiles}
        title="Eliminar archivos"
        message={deleteFileRow === null ? `Seguro que desea eliminar los ${fileSelected.length} archivos seleccionados?` : 'Seguro que desea eliminar el archivo?'}
      />
      <ConfirmationDialog
        keepMounted
        open={confirmarHiperliga}
        onClose={() => setConfirmarHiperliga(false)}
        confirm={onClickEnviarHiperliga}
        title="Enviar Hiperliga"
        message="Seguro que desea enviar el correo con la Hiperliga?"
      />
      <NotificacionOrden
        setOpenNotificacion={setOpenNotificacion}
        openNotificacion={openNotificacion}
        left={left}
        setLeft={setLeft}
        right={right}
        setRight={setRight}
        setOpenSnackError={setOpenSnackError}
        setOpenSnackSuccess={setOpenSnackSuccess}
        setServerMessage={setServerMessage}
        setServerError={setServerError}
        emailData={emailStatusData}
        setOpenAltaOrden={setOpenAltaOrden}
      />
    </div>
  );
});

AltaOrden.propTypes = {
  formName: PropTypes.string,
  comboEstados: PropTypes.array,
  comboMunicipios: PropTypes.array,
  setComboMunicipios: PropTypes.func,
  mapaMunicipios: PropTypes.array,
  setMapaMunicipios: PropTypes.func,
  setServerError: PropTypes.func,
  setOpenSnackError: PropTypes.func,
  idOrden: PropTypes.number,
  setIdOrden: PropTypes.func,
  formData: PropTypes.object,
  setFormData: PropTypes.func,
  rowsOrdenes: PropTypes.array,
  setRowsOrdenes: PropTypes.func,
  comboClientes: PropTypes.array,
  comboAnalistas: PropTypes.array,
  comboOrdenEstatus: PropTypes.array,
  comboHiperliga: PropTypes.array,
  comboGradoEscolar: PropTypes.array,
  setComboGradoEscolar: PropTypes.func,
  mapaUsuarios: PropTypes.array,
  setMapaUsuarios: PropTypes.func,
  comboUsuarios: PropTypes.array,
  setComboUsuarios: PropTypes.func,
  setOpenSnackSuccess: PropTypes.func,
  setServerMessage: PropTypes.func,
  rolUsuario: PropTypes.string,
  setOpenAltaOrden: PropTypes.func
};

export default AltaOrden;
